// colors
import { colors } from '../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  // Waiting room mode styles
  waitingRoomInfo: ({ isUpcomingAppointment }) => ({
    display: 'flex',
    backgroundColor: colors.primary50,
    borderRadius: 12,
    padding: '24px',
    justifyContent: 'space-between',
    marginBottom: isUpcomingAppointment ? 0 : 32,
  }),
  infoRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  infoLabel: {
    fontSize: 14,
    lineHeight: '16px',
    color: colors.neutral500,
    fontWeight: 500,
    textTransform: 'capitalize',
  },
  infoValue: {
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
    fontWeight: 500,
  },
  infoLink: {
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary500,
    fontWeight: 600,
    cursor: 'pointer',
  },
  // Modal styles
  modalOverlay: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: colors.white,
    borderRadius: 12,
    maxWidth: 800,
    maxHeight: '90vh',
    overflow: 'auto',
    outline: 'none',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  modalBody: {
    padding: '16px',
  },
  idCard: {
    width: 180,
    height: 113,
    objectFit: 'cover',
    borderRadius: 8,
  },
});
